export default "__VITE_ASSET__f5MSX5os__"